// extracted by mini-css-extract-plugin
export default {"arrow":"Cy4Y40","mobile":"AZAouv","loadMore":"h0EN1X","mobileLoadMore":"jyGKlA"};